module.exports = __webpack_public_path__ + "static/media/lamina12actrelacionm.ec6f0cad.png";